<lib-dlg titulo="Dados do Requisição" modal="modal-xl" nome="SelRCMS" [visualizar]="visualizar" (onHide)="onHide()"
  styleClassHeader="text-white bg-danger">
  <div class="row">
    <div class="col-sm-12">
      <label for="fornecedor">Selecione o favorecido que deseja visualizar</label>
      <select [compareWith]="compareFn" style="width: 100%;" [ngModel]="favorecido" (ngModelChange)="carregarFavorecido($event)"
        [ngModelOptions]="{standalone: true}" id="fornecedor" class="form-control">
        <option *ngFor="let item of favorecidos" [ngValue]="item">{{item.favorecido.nome}}</option>
      </select>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-12">
      <table class="table table-sm table-eddy">
        <thead>
          <tr>
            <th scope="col" style="width: 5%" class="text-center">Sel.</th>
            <th scope="col" style="width: 55%">Item</th>
            <th scope="col" style="width: 15%" class="text-center">Qtd.</th>
            <th scope="col" style="width: 15%" class="text-right">Valor Unit.</th>
            <th scope="col" style="width: 15%" class="text-right">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of favorecido?.cotacoes; let idx = index">
            <td class="text-center">
              <p-checkbox binary="true" inputId="binary" [(ngModel)]="item.selecionar"></p-checkbox>
            </td>
            <td>
              <span class="word-break-all">
                {{funcaoService.abreviarStr(item.rcmsItem?.produto_unidade?.produto?.nome, 100, true)}}
                ({{item.rcmsItem?.produto_unidade?.unidade?.nome}})
              </span>
            </td>
            <td class="text-center">{{+item.rcmsItem?.quantidade | number : '1.5-5'}}</td>
            <td class="text-right">
              {{+item.valor_unitario | number : '1.5-5'}}
            </td>
            <td class="text-right">
              {{+item.rcmsItem?.quantidade * +item.valor_unitario | number : '1.5-5'}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <ng-container opcoes>
    <button (click)="selecionarFavorecidoEvent()" type="submit"
      class="btn btn-primary btn-sm float-right ml-2">Selecionar</button>
  </ng-container>
</lib-dlg>